import React from 'react';
import { Link } from 'react-router-dom';
import ServiceSlider from '../components/ServiceSlider';
import TechStack from '../components/TechStack';
import Industries from '../components/Industries';
import CompanyStats from '../components/CompanyStats';
import './Home.css';

const Home = () => {
  const pillars = [
    {
      title: 'Web applications',
      description:
        '.NET and PHP platforms for portals, inventory systems, operations tools, and customer-facing products, including APIs and microservices when the system needs to scale in parts.',
    },
    {
      title: 'Mobile apps',
      description:
        'Native iOS and Android, or cross-platform with Flutter, React Native, and .NET MAUI when one codebase should reach both stores.',
    },
    {
      title: 'Digital marketing',
      description:
        'SEO, Google Ads, Meta Ads, and email so the product is findable after launch, with tracking that matches the actual application.',
    },
  ];

  const process = [
    { step: '01', title: 'Discover', description: 'Requirements, users, integrations, and what success looks like in the first 90 days.' },
    { step: '02', title: 'Architect', description: 'UX, data model, and service boundaries are written down before build starts, not implied.' },
    { step: '03', title: 'Build', description: 'Weekly demos, code reviews, and a staging environment you can click through.' },
    { step: '04', title: 'Launch', description: 'Production release, store submission where needed, and a growth plan if you want one.' },
  ];

  return (
    <main className="home">
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <p className="hero-eyebrow">Softnova · Web · Mobile · Digital</p>
            <h1 className="hero-title">
              Software that operations
              <span className="gradient-text"> teams actually use</span>
            </h1>
            <p className="hero-subtitle">
              We design and develop .NET and PHP web applications, iOS and Android apps,
              and the digital marketing around them, from inventory dashboards to
              field-ready mobile products.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn btn-primary">Start a conversation</Link>
              <Link to="/services" className="btn btn-secondary">Our services</Link>
            </div>
          </div>
          <div className="hero-visual">
            <img src="/images/slide-inventory.png" alt="Inventory management web dashboard" />
          </div>
        </div>
      </section>

      <CompanyStats />
      <ServiceSlider />

      <section className="services-preview section">
        <div className="container">
          <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>Core services</p>
          <h2 className="section-title">What we build</h2>
          <p className="section-subtitle">
            Three lines of work, one team, so the backend, the app, and acquisition are not three separate vendors.
          </p>
          <div className="services-grid">
            {pillars.map((pillar) => (
              <div key={pillar.title} className="service-card">
                <h3 className="service-title">{pillar.title}</h3>
                <p className="service-description">{pillar.description}</p>
              </div>
            ))}
          </div>
          <div className="text-center" style={{ marginTop: '2.5rem' }}>
            <Link to="/services" className="btn btn-primary">View all services</Link>
          </div>
        </div>
      </section>

      <TechStack />
      <Industries />

      <section className="process-section section">
        <div className="container">
          <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>How we work</p>
          <h2 className="section-title">A straightforward delivery path</h2>
          <div className="process-grid">
            {process.map((item) => (
              <div key={item.step} className="process-card">
                <div className="process-step">{item.step}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Have a project in mind?</h2>
            <p className="cta-subtitle">
              Share a short brief. We reply to info@softnovasolutions.com with next steps.
            </p>
            <Link to="/contact" className="btn btn-light" style={{ fontSize: '1.125rem', padding: '14px 40px' }}>
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
